<template>
  <div class="h-margin-top-50">
    <div v-if="loaders.courses" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="library__group h-center-align" v-else>
      <div class="library__collection">
        <CourseCard v-for="(course, index) in courses" :key="index" :course="course"></CourseCard>
        <CourseModal modal-key="courseModal"></CourseModal>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import CourseCard from '../professional-development/CourseCard.vue';
  import CourseModal from '../professional-development/CourseModal.vue';

  export default {
    name: 'ProfessionalDevelopmentLayout',
    components: {
      MoonLoader,
      CourseCard,
      CourseModal,
    },
    computed: {
      ...mapGetters('professionalDevelopment', ['loaders', 'initializers', 'courses']),
    },
    beforeMount() {
      if (!this.initializers.courses) {
        this.$store.dispatch('professionalDevelopment/getCourses');
      }
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
  };
</script>
